import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { axiosPost } from "../../react_axios/Axios";  // import axiosPost
import { verifyLoginUrl, toastSuccess, toastError } from "../../utils/constants"; // import constants
import { verifyLogin_action } from '../../actions/user_login_auth_actions/user_login_auth_action';
import { ToastContainer } from 'react-toastify';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            Email: '',
            Password: '',
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { Email, Password } = this.state;
        this.setState({ isLoading: true });

        try {
            const data = await this.props.verifyLogin_action(Email, Password);

            if (data.error !== 1) {
                const res = data.data;

                // store everything in localStorage
                localStorage.setItem("ItmeCorporateUser", JSON.stringify(res));
                localStorage.setItem("UserID", res["UserID"]);
                localStorage.setItem("Email", res["Email"]);
                localStorage.setItem("UserName", res["UserName"]);
                localStorage.setItem("accessToken", res["accessToken"]);
                localStorage.setItem("refreshToken", res["refreshToken"]);
                localStorage.setItem("isVerified", true);

                toastSuccess('Login successful');
                this.props.navigate('/cms/manage'); // redirect to CMS home
            } else {
                toastError(data.msg ? data.msg : "Invalid credentials");
            }
        } catch (err) {
            console.error(err);
            toastError("Login failed");
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { isLoading, Email, Password } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                {/* <Header /> */}
                <ToastContainer />
                <main className="main-area fix" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                    <section className="myContactPage contactUs_page d-flex align-items-center" style={{ minHeight: '100vh' }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-5 col-md-6 col-sm-10">
                                    <div className="p-4 p-md-5 shadow-sm rounded bg-white d-flex flex-column text-center">
                                        {/* Logo + Title */}
                                        <div className="mb-2 text-center">
                                            <img
                                                src="https://corporate.india-itme.com/itme2026/document/Static/1/logo_4.png"
                                                alt="Logo"
                                                className="img-fluid mb-3 d-block mx-auto"
                                                style={{ maxHeight: '80px' }}
                                            />
                                            <h2
                                                className="section-heading mb-2"
                                                style={{ fontWeight: 600, fontSize: '1.5rem' }}
                                            >
                                                ITME 2026 CMS Login
                                            </h2>
                                            <p className="text-muted mb-0">
                                                Welcome back! Please login to your account
                                            </p>
                                        </div>

                                        {/* Form */}
                                        <form onSubmit={this.handleSubmit} className="text-start">
                                            <div className="mb-3">
                                                <label className="form-label" style={{ color: 'orange' }}>
                                                    Email address
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="Email"
                                                    value={Email}
                                                    onChange={this.handleChange}
                                                    placeholder="Enter your Email"
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label" style={{ color: 'orange' }}>
                                                    Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="Password"
                                                    value={Password}
                                                    onChange={this.handleChange}
                                                    placeholder="Enter your Password"
                                                    required
                                                />
                                            </div>

                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg rounded-pill"
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? "Logging in..." : "Login"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                {/* <Footer /> */}
            </>
        );
    }
}

export default withRouter(connect(null, { verifyLogin_action })(Login));
